var XPortal = XPortal || {};
XPortal.DropdownBtns = (function () {
    var dropdownBtns = {};

    dropdownBtns.init = function () {
        const $body = $('body');
        this.dropdownHover.init();
        this.notificationExpander.init();
        this.gridButtons.init($body);
        this.gridButtons.initEvents($body);
    };

    dropdownBtns.openDotsIfPanelInside = function ($panel) {
        var $dots = $panel.closest('.dots');
        if ($dots.length && !$dots.hasClass('open')) {
            $dots.find('.dropdown-toggle').dropdown('toggle');
        }

        var $serviceDots = $panel.closest('.grid-parent').find('.k-grid-header .dots');
        if ($serviceDots.length) {
            $serviceDots.removeClass('show');
            $serviceDots.find('.dropdown-menu').removeClass('show');
        }
    };

    dropdownBtns.notificationExpander = {
        init: function () {
            $(document).off('click.xpandlist').on('click.xpandlist', '.xpand-list > *:first-child', function (e) {
                e.preventDefault();
                e.stopPropagation();

                var $this = $(this),
                    $cnt = $this.parent();

                if (!$cnt.hasClass('opened')) {
                    $cnt.addClass('opened');
                    $this.nextAll().stop().slideDown(300);
                }
                else {
                    $cnt.removeClass('opened');
                    $this.nextAll().stop().slideUp(300);
                }
            });
        }
    };

    dropdownBtns.gridButtons = {
        checkTimeOut: null,
        init: function ($wrapper) {
            if (!$wrapper.find('.dropdown.dropdown-hover.desktop-inline:not(.grid-buttons-inited)').length) {
                return;
            }

            var $buttons = $wrapper.find('.dropdown.dropdown-hover.desktop-inline');
            if ($buttons.parents('.grid-action-header').length > 0) {
                setTimeout(function () {
                    dropdownBtns.gridButtons.check($wrapper);
                }, 500);
            } else {
                dropdownBtns.gridButtons.check($wrapper);
            }

            $wrapper.find('.dropdown.dots:not(.grid-service-dd-dots):not(.dropdown-dots-inited)').on('hide.bs.dropdown hide.dots.dropdown', function () {
                var $list = $(this).find('.columns-list-wrapper, .filters-list-wrapper, .grid-calendar-buttons-wrapper');
                if (!$list.length)
                    return;

                $list.removeClass('open');
                setTimeout(function () {
                    $list.removeClass('right');
                }, 300);
            }).addClass('dropdown-dots-inited');
        },
        initEvents: function ($wrapper) {
            $(window).on('resize.gridbuttonseventgroup', function () { dropdownBtns.gridButtons.checkWithTimeout($wrapper); })
                .on('orientationchange.gridbuttonseventgroup', function () { dropdownBtns.gridButtons.checkWithTimeout($wrapper); });

            $(document).on('click', '.grid-service-dd-dots .dropdown-toggle', function () {
                $('.grid-service-dd-dots.show').not($(this).closest('.grid-service-dd-dots')).removeClass('show');
                $('.dropdown-menu-in-table.show').not($(this).next()).removeClass('show');
            });
        },
        checkWithTimeout: function ($wrapper) {
            clearTimeout(dropdownBtns.gridButtons.checkTimeOut);
            dropdownBtns.gridButtons.checkTimeOut = setTimeout(function () {
                dropdownBtns.gridButtons.check($wrapper);
            }, 100);
        },
        check: function ($wrapper, contentWidth) {
            let $elems;
            let $dotsElems;
            if (contentWidth > 0) {
                $elems = $wrapper.find('.dropdown.dropdown-hover.desktop-inline');
                $dotsElems = $wrapper.find('.dropdown.dropdown-hover.dots');
            }
            else {
                $elems = $wrapper.find('.dropdown.dropdown-hover.desktop-inline').not('.grid-header-resize .dropdown.dropdown-hover.desktop-inline');
                $dotsElems = $wrapper.find('.dropdown.dropdown-hover.dots').not('.grid-header-resize .dropdown.dropdown-hover.dots');
            }

            $elems.each(function () {
                const $this = $(this);
                const $elemWrapper = $this.closest('.input-group-flex');
                const $dots = $this.next();

                // Initial setup
                $this.addClass('d-none');
                $dots.addClass('d-none');

                // Determine allowed width
                let allowedWidth = contentWidth || $elemWrapper.width();
                if ($this.closest('.grid-action-header').length > 0) {
                    allowedWidth = Math.max(allowedWidth, 100); // Ensure a minimum width of 100 for grid header actions
                }

                // Reinitialize buttons
                $this.removeClass('d-none');
                dropdownBtns.gridButtons.moveButtons($this, $dots, allowedWidth);
                $this.addClass('grid-buttons-inited');

                // Remove opacity class after initialization
                $elemWrapper.removeClass('opacity-0');
            });

            $dotsElems.each(function () {
                const $this = $(this);
                const $dropdownMenu = $this.find('.dropdown-menu');
                const $dropdownToggle = $this.find('.dropdown-toggle');

                // Check if all dropdown menu children have the 'd-none' class
                const allHidden = $dropdownMenu.children().toArray().every(child => $(child).hasClass('d-none'));

                // Toggle visibility of the dropdown button
                $dropdownToggle.toggleClass('d-none', allHidden);
            });
        },
        moveButtons: function (wrapper, dots, allowedWidth) {
            const $tagsContainer = wrapper.parents('.edit-btns-wrapper').find('.current-tags');
            const $menu = wrapper.find('.dropdown-menu:first');
            const dotsBtn = wrapper.next('.dropdown.dropdown-hover.dots');
            let totalWidth = 0, numberOfButtons = 0;

            const $buttons = $menu.children();
            if ($buttons.length === 1 && $buttons.first().hasClass('hide-change-view-action')) {
                $buttons.addClass('d-none');
                $buttons.closest('.grid-actions-col').addClass('d-none');
                return;
            }

            // Ensure checkbox and save button positions
            const $checkbox = $buttons.find('.row-checkbox');
            if ($checkbox.length) {
                const $checkboxBtn = $checkbox.closest('.dropdown-item');
                $checkboxBtn.addClass('checkbox-wrp').prependTo($menu);
            }

            const $saveBtn = $buttons.filter('.save-button-right-wrp');
            if ($saveBtn.length) {
                $saveBtn.prependTo($menu);
            }

            const isServiceSell = wrapper.hasClass('grid-service-dd-line');
            const isCompactMode = isServiceSell && wrapper.closest('.input-group-flex[data-state="compact-mode"]').length;

            //Adjust the width only if the dot button is necessary
            if (dotsBtn && dotsBtn.length) {
                dotsBtn.addClass('d-none');
            }
            $buttons.removeClass('d-none');

            // First determine if all the buttons will fit
            $buttons.each(function () {
                const $btn = $(this);
                const btnWidth = $btn.hasClass('hide-change-view-action') ? 0 : $btn.outerWidth(true);
                totalWidth += btnWidth;
            });

            const needsOverflow = totalWidth > allowedWidth;

            // Then find out how we are going to split the dot bttns and menu btts
            if (needsOverflow) {
                dotsBtn.removeClass('d-none');
                const dotsWidth = dotsBtn.outerWidth(true);
                allowedWidth -= dotsWidth;
                dotsBtn.addClass('d-none');

                totalWidth = 0;
                $buttons.each(function () {
                    const $btn = $(this);
                    const btnWidth = $btn.hasClass('hide-change-view-action') ? 0 : $btn.outerWidth(true)
                    totalWidth += btnWidth;
                    if (totalWidth <= allowedWidth) {
                        numberOfButtons++;
                    }
                });
            } else {
                numberOfButtons = $buttons.length;
            }

            const $dotsMenu = dots.find('.dropdown-menu:first');
            const $dotsButtons = $dotsMenu.children();

            // Ensure consistency in checkbox state in dots menu
            if ($checkbox.length) {
                $dotsButtons.find('.row-checkbox').closest('.dropdown-item').addClass('checkbox-wrp');
            }

            // Hide all buttons initially
            $buttons.not('.lbl-save-state-wrp').addClass('d-none');
            $dotsButtons.addClass('d-none');

            // Show buttons that fit and hide the rest
            $buttons.slice(0, Math.max(0, numberOfButtons)).removeClass('d-none');
            const remainingDots = numberOfButtons - ($checkbox.length ? 1 : 0);
            $dotsButtons.slice(Math.max(0, remainingDots)).removeClass('d-none');

            // Check if all dots menu buttons are effectively hidden
            const allHidden = $dotsButtons.toArray().every(button => {
                const $button = $(button);
                return $button.hasClass('d-none') ||
                    $button.hasClass('hide-change-view-action') ||
                    ($button.hasClass('lbl-save-state-wrp') && $button.find('.lbl-save-state').hasClass('d-none'));
            });

            // Toggle dots visibility
            if ((isCompactMode || numberOfButtons < $buttons.length) &&
                dotsMenuHasVisibleItems(dots) && !allHidden) {
                dots.removeClass('d-none');
                wrapper.parents('.grid-action-header').addClass('dots-menu-visible');
            } else {
                dots.addClass('d-none');
                wrapper.parents('.grid-action-header').removeClass('dots-menu-visible');
            }

            // Handle tags if present
            if ($tagsContainer.length) {
                this.handleAppliedTags($tagsContainer, $buttons, $dotsButtons);
            }

            // Helper to check if dots menu has visible items
            function dotsMenuHasVisibleItems(dots) {
                return dots.find('.dropdown-item:not(.checkbox-wrp):not(.save-button-right-wrp):not(.lbl-save-state-wrp)').length > 0;
            }
        },
        handleAppliedTags: function ($tagsContainer, $buttons, $dotsButtons) {
            const isTagsApplied = $tagsContainer.find('.tag-item').length > 0;
            const $parent = $('.edit-btns-wrapper_header');
            const $headerItems = $parent.find('.with-header-items');
            const $btnsWrap = $parent.find('.dropdown.dropdown-hover.desktop-inline');
            const $btns = $btnsWrap.find('li.dropdown-item');
            const $dotsWrap = $parent.find('.dropdown.dropdown-hover.dots');

            $parent.addClass('with-tags');

            if (isTagsApplied) {
                // When tags are applied
                $buttons.addClass('d-none');
                $headerItems.addClass('tags-applied');
                $buttons.slice(0, 2).removeClass('d-none'); // Show only first 2 buttons
                $dotsButtons.slice(0, 2).addClass('d-none'); // Hide corresponding dot buttons
            } else {
                // When tags are not applied
                $headerItems.removeClass('tags-applied');
                const freeSpace = $parent.width() - $headerItems.width();
                let totalWidth = 0;
                let showedBtns = 0;

                $btns.removeClass('d-none'); // Reset visibility

                // Adjust buttons based on available space
                $btns.each(function (index) {
                    const $button = $(this);
                    const buttonWidth = $button.outerWidth(true);

                    if (totalWidth + buttonWidth <= freeSpace) {
                        totalWidth += buttonWidth;
                        showedBtns++;
                        $button.removeClass('d-none'); // Show button
                        $dotsButtons.eq(index).addClass('d-none'); // Hide corresponding dot button
                    } else {
                        $button.addClass('d-none'); // Hide button
                        $dotsButtons.eq(index).removeClass('d-none'); // Show corresponding dot button
                    }
                });

                // Hide dots if all buttons fit
                if (showedBtns === $btns.length) {
                    $dotsWrap.addClass('d-none');
                } else {
                    $dotsWrap.removeClass('d-none');
                }
            }
        },

        adjustMenuPosition: function ($dotsBtn) {
            if (!$dotsBtn.closest('.k-grid').length) return;
            var dotsOffset = $dotsBtn.offset();
            var $menu = $dotsBtn.next();
            $menu.css({
                'left': dotsOffset.left + 'px',
                'top': (dotsOffset.top + $dotsBtn.outerHeight()) + 'px',
            });
        }
    };

    dropdownBtns.dropdownHover = {
        init: function () {
            var $body = $('body');
            $body.on('click', '.dropdown-submenu > .dropdown-toggle', function (e) {
                var $this = $(this);
                $this.next('ul').add($this.closest('.dropdown-submenu')).toggleClass('show');
                e.stopImmediatePropagation();
                e.preventDefault();
            });

            $body.on('click', '.dropdown-menu:not(.toolbar) .di-content', function () {
                dropdownBtns.dropdownHover.doClick(this);
            });

            $body.on('click', '.dropdown_view-select', function () {
                XPortal.DropdownBtns.gridButtons.checkWithTimeout($('.grid-action-header'));
            });

            $body.on('click', '.dropdown.dots .dropdown-toggle', function (event) {
                event.preventDefault();
                var $parent = $(this).parent();
                $parent.toggleClass('show');
                $parent.find('.dropdown-menu').toggleClass('show');
            });

            $body.on('click', '[data-role="columnmenu"] .dropdown.dots .dropdown-toggle', function (event) {
                dropdownBtns.gridButtons.adjustMenuPosition($(this));
            });

            $body.on('mouseover', '[data-role="columnmenu"] .dropdown.dots .dropdown-toggle', function (event) {
                dropdownBtns.gridButtons.adjustMenuPosition($(this));
            });

            $body.on('click', function (e) {
                var $target = $(e.target);
                var $subMenu = $target.closest('.dropdown-submenu');
                if (!$subMenu.length) {
                    $('.dropdown-submenu').removeClass('show').find('.dropdown-menu').removeClass('show');
                }

                if ($target.closest('.dropdown.dots').length || $target.closest('.k-animation-container').length) {
                    return;
                }

                var $parent = $('.dropdown.dots');
                $parent.removeClass('show');
                $parent.find('.dropdown-menu').removeClass('show');
                $parent.trigger('hide.dots.dropdown');
            });

            $('header .dropdown').each(function () {
                dropdownBtns.dropdownHover.setHeaderDDPosition(this);
            });

            if (!('ontouchstart' in window)) {
                $('header').on('mouseenter', '.dropdown', function () {
                    dropdownBtns.dropdownHover.setHeaderDDPosition(this);
                });
            }
        },
        setHeaderDDPosition: function (obj) {
            if ($('.dropdown-toggle', obj).length < 1 || $('.dropdown-menu', obj).length < 1)
                console.warn('temp: Popper cant be initialized - there is no container', { obj, toggle: $('.dropdown-toggle', obj), menu: $('.dropdown-menu', obj) });
            else
                new Popper($('.dropdown-toggle', obj), $('.dropdown-menu', obj), { 'placement': 'bottom-start' });
        },
        doClick: function (item) {
            var $dropDown = $(item).parents('.dropdown');

            if ($dropDown.hasClass('dropdown-changable') && !($(item).hasClass("savesettingsbox"))) {
                var $itemText = $(item).find('.dm-item-text');
                if ($itemText.length) {
                    $dropDown.find('.dropdown-toggle').html($itemText.html());
                }
            }

            if ($dropDown.is('.notifications-dd')) {
                return;
            }

            dropdownBtns.gridButtons.check($dropDown.closest('.input-group-flex'));
        }
    };

    dropdownBtns.changePosition = function (btn) {
        var btnClass = 'dropdown-moved-btn';
        var tdClass = 'dropdown-menu-activated';

        var $oldTd = $('.' + tdClass);
        $oldTd.find('input.row-checkbox').prop('checked', false);
        $('.' + btnClass).removeClass(btnClass);
        $oldTd.removeClass(tdClass);

        var $btn = $(btn);
        $btn.addClass(btnClass);

        var $td = $btn.closest('td.service');
        var $chb = $td.find('input.row-checkbox');

        if (!$chb.is(':checked')) {
            $chb.prop('checked', true);
            $td.addClass(tdClass);
        }

        $('.dropdown-cloned').remove();
        var $selectMenu = $btn.next();

        var notifyAction = $selectMenu.find("a[data-action = 'NotificationSubscription']");
        if (notifyAction.length > 0) { //process conditional dropdown menu commands
            var kgrid = $($btn.closest(".k-grid")).data("kendoGrid");
            var viewId = $btn.closest(".k-grid").get(0).id;
            notifyAction = $selectMenu.find("a[data-action = 'NotificationSubscription']");
            var gridNotifications = XPortal.Grid.AssignedNotificationsItems.find(i => i.viewId == viewId);
            var currentObj = kgrid.dataItem($btn.closest("tr"));

            if (gridNotifications && currentObj && gridNotifications.assignedNotifications) {
                if (gridNotifications.assignedNotifications.indexOf(currentObj.UniqueId.trim()) > -1) {
                    $(notifyAction).html('');
                    $(notifyAction).append(kgrid.options.commands.notificationsubscription.remicon + '<span class="dm-item-text">' + kgrid.options.commands.notificationsubscription.remtitle + '</span>');
                }
                else {
                    $(notifyAction).html('');
                    $(notifyAction).append(kgrid.options.commands.notificationsubscription.addicon + '<span class="dm-item-text">' + kgrid.options.commands.notificationsubscription.addtitle + '</span>');
                }
            }
        }
        var $selectMenuClone = $selectMenu.clone().removeClass('show').addClass('dropdown-cloned');
        setTimeout(function () {
            $selectMenuClone.appendTo($btn.parents('.k-grid'));
            XPortal.DropdownBtns.calculatePosition();
            $selectMenuClone.show(200);
        }, 10);

        $(window).on('scroll', function () { XPortal.DropdownBtns.calculatePosition(); });
        $(window).on('orientationchange', function () { XPortal.DropdownBtns.calculatePosition(); });
        $(window).on('resize', function () { XPortal.DropdownBtns.calculatePosition(); });

        $(document).on('click', function () {
            $('.dropdown-cloned').slideUp(200);
            setTimeout(function () {
                $('.dropdown-cloned').remove();
            }, 200);
        });

        $('.k-grid-content').on('scroll', function () {
            XPortal.DropdownBtns.calculatePosition();
        });
    };

    dropdownBtns.calculatePosition = function () {
        $selectMenu = $('.dropdown-cloned');

        if (!$selectMenu.length) {
            return;
        }

        var $thisBtn = $('.dropdown-moved-btn');
        if ($thisBtn.length > 0) {
            var $grid = $thisBtn.parents('.k-grid');

            var gridOffset = $grid.offset();
            var gridTop = gridOffset.top;
            var gridLeft = gridOffset.left;

            var ddOffset = $thisBtn.offset();
            var ddTop = ddOffset.top;
            var ddLeft = ddOffset.left;

            var div = ddTop + 25 + $selectMenu.height() * 2 + $(window).scrollTop() + $grid.scrollTop() > gridTop + $grid.height() ? $selectMenu.height() + 50 : 0;

            $selectMenu.css({
                'top': ddTop - gridTop + 25 - div,
                'left': ddLeft - gridLeft
            });
        }
    };

    return dropdownBtns;
}());

$(function () {
    XPortal.DropdownBtns.init();
});